import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"

type Props = {
    style?: Maybe<Record<string, any>>
    text?: Maybe<string>
    hidden?: Maybe<boolean>
}

class OverrideNotification extends React.PureComponent<Props> {
    render() {
        if (this.props.hidden) {
            return null
        }
        return (
            <span
                style={{
                    position: "absolute",
                    ...this.props.style,
                }}
                className="location-override">
                {this.props.text}
            </span>
        )
    }
}

export default OverrideNotification
